import React from 'react';
import { withRouter } from '../../../RouterCompatibility';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import ConversionItemContent from './ConversionItemContent';
import { actions } from './ConversionItemContent.actions';
import {
    mainSelector,
    isEmpty
} from './ConversionItemContent.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    data: mainSelector,
    isEmpty: isEmpty
});

const ConversionItemContentComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.conversions.loading
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getConversion: actions.getConversion,
            getRegions: actions.getRegions
        };
    }
)(withRouter(ConversionItemContent));

export default ConversionItemContentComponent;
